<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Meus dados fiscais / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card card-table shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                    <div class="row mt-1">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">CNPJ</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: xx.xxx.xxx/xxxx-xx"
                                                    v-model="client.document_formatted" disabled>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">Regime Tributário</label>
                                            <div class="input-group mb-3">
                                               <input type="text" class="form-control" v-if="client_fiscal.tax_regime != ''" v-model="client_fiscal.tax_regime" disabled>
                                                 <input type="text" class="form-control" v-else value="Não informado" disabled>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">CNAE Fiscal</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client_fiscal.cnae_fiscal != ''" class="form-control" v-model="client_fiscal.cnae_fiscal" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Descrição CNAE</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client_fiscal.cnae_fiscal_description != ''" class="form-control" v-model="client_fiscal.cnae_fiscal_description" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Anexo Fiscal CNAE</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client_fiscal.attachment_fiscal != ''" class="form-control" v-model="client_fiscal.attachment_fiscal" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">CNAE Secundário Fiscal</label>
                                            <div class="input-group mb-3">
                                                 <input type="text" v-if="client_fiscal.cnae_secondary_fiscal != ''" class="form-control" v-model="client_fiscal.cnae_secondary_fiscal" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Descrição CNAE Secundário</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client_fiscal.cnae_secondary_fiscal_description != ''" class="form-control" v-model="client_fiscal.cnae_secondary_fiscal_description" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Anexo Fiscal CNAE Secundário</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client_fiscal.attachment_secondary_fiscal != ''" class="form-control" v-model="client_fiscal.attachment_secondary_fiscal" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Registro Estadual</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client_fiscal.state_registration != ''" class="form-control" v-model="client_fiscal.state_registration" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Registro Municipal</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client_fiscal.municipal_registration != ''" class="form-control" v-model="client_fiscal.municipal_registration" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Fator R</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client_fiscal.factor_r == '1'" class="form-control" value="Sim" disabled>
                                                <input type="text" v-else class="form-control" value="Não" disabled>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Data situação cadastral</label>
                                            <div class="input-group mb-3">
                                                <input type="date" v-if="client_fiscal.date_situation_cadastral != ''" class="form-control" v-model="client_fiscal.date_situation_cadastral" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Natureza jurídica</label>
                                            <div class="input-group mb-3">
                                               <input type="text" v-if="client_fiscal.legal_nature != ''" class="form-control" v-model="client_fiscal.legal_nature" disabled>
                                               <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Situação cadastral</label>
                                            <div class="input-group mb-3">
                                               <input type="text" v-if="client_fiscal.situation_cadastral != ''" class="form-control" v-model="client_fiscal.situation_cadastral" disabled>
                                               <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Tamanho empresa</label>
                                            <div class="input-group mb-3">
                                               <input type="text" v-if="client_fiscal.company_size != ''" class="form-control" v-model="client_fiscal.company_size" disabled>
                                               <input type="text" v-else class="form-control" value="Não informado" disabled>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'


export default {
    directives: { mask },
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {},
            banks: {},
            client_id: '',
            attachment_fiscal_options: ['Anexo I', 'Anexo II', 'Anexo III', 'Anexo IV'],
            factor_r_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            factor_r_multiselect: '',
            client_fiscal: {
                id: '',
                tax_regime: '',
                state_registration: '',
                municipal_registration: '',
                cnae_fiscal: '',
                cnae_fiscal_description: '',
                attachment_fiscal: '',
                cnae_secondary_fiscal: '',
                cnae_secondary_fiscal_description: '',
                attachment_secondary_fiscal: '',
                factor_r: '',
                date_situation_cadastral: '',
                legal_nature: '',
                situation_cadastral: '',
                company_size: '',
                bank: '',
                agency: '',
                account: '',
                type_account: '',
                observation: ''
            },
            enable_error_list: false,
            errors: [],

        }
    },

    computed: {
        isDisabled: function () {
            return this.client_fiscal.tax_regime != '';
        }
    },
     beforeMount() {
        const id =  localStorage.getItem('client_id');
        this.client.id = id;
    },
    mounted() {
        this.isLoading = false;
        this.getFiscalClient();
    },
    methods: {
        onCancel() { },
        setCapitalize(text) {
            return capitalize(text);
        },       
        getFiscalClient() {
            api.get('/client-user/' + this.client.id + '/fiscal')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    if (response.data.fiscal_client.length != 0) {
                        this.client_fiscal = response.data.fiscal_client;
                        this.$refs.myChild.updateTextEditor(this.client_fiscal.observation);
                        if (this.client_fiscal.factor_r == '1') {
                            this.factor_r_multiselect = { type: '1', value: 'Sim' };
                        } else {
                            this.factor_r_multiselect = { type: '0', value: 'Não' };
                        }

                       
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

    }
}
</script>

<style lang="scss" scoped></style>